import React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgPresentationUnlockSimpleIcon = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "Presentation screen with a simple unlock symbol in the center",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}

    <g clipPath="url(#clip0_25537_52914)">
      <path
        d="M16.875 3.75H3.125C2.77982 3.75 2.5 4.02982 2.5 4.375V13.75C2.5 14.0952 2.77982 14.375 3.125 14.375H16.875C17.2202 14.375 17.5 14.0952 17.5 13.75V4.375C17.5 4.02982 17.2202 3.75 16.875 3.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 14.375L15 17.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.375L5 17.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.75V1.875"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_25537_52914)">
        <path
          d="M12.5 8.25H7.5C7.36193 8.25 7.25 8.36193 7.25 8.5V12C7.25 12.1381 7.36193 12.25 7.5 12.25H12.5C12.6381 12.25 12.75 12.1381 12.75 12V8.5C12.75 8.36193 12.6381 8.25 12.5 8.25Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 8.25V7.25C8.75 6.91848 8.8817 6.60054 9.11612 6.36612C9.35054 6.1317 9.66848 6 10 6C10.3315 6 10.6495 6.1317 10.8839 6.36612"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_25537_52914">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_25537_52914">
        <rect
          width="8"
          height="8"
          fill="white"
          transform="translate(6 5.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const PresentationUnlockSimpleIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgPresentationUnlockSimpleIcon />
  </BaseIcon>
);

export default PresentationUnlockSimpleIcon;
